<template>
  <div class="contest-details">
    <div class="container">
      <div class="row">
        <div class="col text-right">
          <button class="btn close-button" @click="onClickClose()">
            Close
          </button>
        </div>
      </div>
      <div class="detail" v-if="item">
        <div class="row">
          <div class="col-lg-6">
            <h5 class="title-detail">{{ item.title }}</h5>
            <div class="detail-description">
              <div class="detail-img">
                <img :src="item.thumbnailUrl" alt="" />
              </div>
              <div class="detail-name">
                <h5>{{ item.name }}</h5>
                <div class="description">
                  <div class="contest-name-description">
                    <div class="attributes">
                      <div class="attribute">
                        <div class="attribute-name">Owner:</div>
                        <div class="attribute-value">owner name</div>
                      </div>
                      <div class="attribute">
                        <div class="attribute-name">Listing Date:</div>
                        <div class="attribute-value">24/11/2020</div>
                      </div>
                      <div class="attribute">
                        <div class="attribute-name">Start date:</div>
                        <div class="attribute-value">
                          {{ formatDate(item.startDate) }}
                        </div>
                      </div>
                      <div class="attribute">
                        <div class="attribute-name">Next end date:</div>
                        <div class="attribute-value">
                          {{ formatDate(item.endDate) }}
                        </div>
                      </div>
                      <div class="attribute">
                        <div class="attribute-name">Instances left:</div>
                        <div class="attribute-value">3</div>
                      </div>
                      <div class="attribute">
                        <div class="attribute-name">Prizes:</div>
                        <div class="attribute-value">
                          {{ item.stats.prizeCount }}
                        </div>
                      </div>
                      <div class="attribute">
                        <div class="attribute-name">Type:</div>
                        <div class="attribute-value">
                          {{ item.campaignType }}
                        </div>
                      </div>
                      <div class="attribute">
                        <div class="attribute-name">Affiliations:</div>
                        <div class="attribute-value">
                          {{ item.stats.affiliationCount }}
                        </div>
                      </div>
                      <div class="attribute">
                        <div class="attribute-name">Submissions:</div>
                        <div class="attribute-value">
                          {{ item.stats.submissionCount }}
                        </div>
                      </div>
                      <div class="attribute">
                        <div class="attribute-name">Distribution:</div>
                        <div class="attribute-value">
                          {{ item.stats.distributionCount }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="contest-name-description">
                    <div class="attributes">
                      <div class="attribute">
                        <div class="attribute-name">Address:</div>
                        <div class="attribute-value">
                          Street name<br />
                          City<br />
                          Country Code<br />
                          Country
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <perfect-scrollbar>
              <div class="list-description">
                <h5 class="head-title">Description</h5>
                <div class="text-description" v-html="item.description"></div>
              </div>
              <div class="list-description" v-if="item.rules">
                <h5 class="head-title">How to participate</h5>
                <div class="text-description" v-html="item.rules"></div>
              </div>
              <div class="list-description">
                <h5 class="head-title">Term & Conditions</h5>
                <div class="text-description" v-html="item.terms"></div>
              </div>
              <div class="list-description">
                <h5 class="head-title">Promotional Material</h5>
                <div class="text-description">
                  <table class="table-contest">
                    <thead>
                      <tr>
                        <th>File Name</th>
                        <th style="width: 120px">Size</th>
                        <th style="width: 120px"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Marketing_Flyer.jpg</td>
                        <td>1.2 MB</td>
                        <td><a href="#">Download</a></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="list-description">
                <h5 class="head-title">Prizes</h5>
                <div class="text-description">
                  <table class="table-contest">
                    <thead>
                      <tr>
                        <th>Title</th>
                        <th style="width: 120px">Value</th>
                        <th style="width: 120px">Sponsor</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(i, index) in item.prizes" :key="index">
                        <td>{{ i.name }}</td>
                        <td>{{ i.valueCurrency }}</td>
                        <td>{{ i.sponsor }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="list-description">
                <h5 class="head-title">Join Contest</h5>
                <div class="text-description">
                  <p>
                    This contest requires every experience that joins to
                    contribute a prize.
                  </p>
                  <p>Minimum value: USD 100.00</p>
                </div>
              </div>
            </perfect-scrollbar>
          </div>
          <div class="col-lg-6">
            <div class="box-experiences">
              <h5 class="title-detail">Participating Experiences</h5>
              <div class="search">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Search Affiliations"
                />
              </div>
            </div>
            <div class="list-experiences">
              <div class="row" v-if="participating.results.length > 0">
                <div
                  class="col-lg-4"
                  v-for="(item, index) in participating.results"
                  :key="index"
                >
                  <div class="shadow-sm pb-2 bg-white rounded">
                    <div class="title-experiences">{{ item.title }}</div>
                    <div class="owner">Owner:</div>
                    <div class="img-experiences">
                      <img :src="img" alt="Business name" />
                    </div>
                    <div class="date-post">
                      Last update: {{ item.updatedAt }}
                    </div>
                    <div class="location">
                      <label>Location:</label>
                    </div>
                    <div class="category">
                      <label>Category:</label>
                      <span v-for="(categorie, i) in item.categories" :key="i"
                        >{{ categorie.title }} |</span
                      >
                    </div>
                    <div class="icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="31"
                        height="24.024"
                        viewBox="0 0 31 24.024"
                      >
                        <g
                          id="ew-icon_new-message"
                          transform="translate(0.5 0.5)"
                        >
                          <path
                            id="Path_12083"
                            data-name="Path 12083"
                            d="M35.991,11.58H9.018A1.515,1.515,0,0,0,7.5,13.1v15.03a1.515,1.515,0,0,0,1.518,1.518h2.058V34.1a.486.486,0,0,0,.832.343l4.8-4.8H35.982A1.515,1.515,0,0,0,37.5,28.128V13.1A1.5,1.5,0,0,0,35.991,11.58Z"
                            transform="translate(-7.5 -11.58)"
                            fill="none"
                            stroke="#b9b9b9"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-miterlimit="10"
                            stroke-width="1"
                          />
                          <g
                            id="Group_4748"
                            data-name="Group 4748"
                            transform="translate(3.969 4.545)"
                          >
                            <line
                              id="Line_194"
                              data-name="Line 194"
                              x2="22.069"
                              fill="none"
                              stroke="#b9b9b9"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              stroke-width="1"
                            />
                            <line
                              id="Line_195"
                              data-name="Line 195"
                              x2="22.069"
                              transform="translate(0 4.304)"
                              fill="none"
                              stroke="#b9b9b9"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              stroke-width="1"
                            />
                            <line
                              id="Line_196"
                              data-name="Line 196"
                              x2="14.576"
                              transform="translate(0 8.617)"
                              fill="none"
                              stroke="#b9b9b9"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              stroke-width="1"
                            />
                          </g>
                        </g>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-if="participating.results.length == 0">
                <div style="padding-left: 15px; padding-top: 15px">
                  There is no participating experiences right now.
                </div>
              </div>
            </div>
            <div class="box-experiences" style="margin-top: 50px">
              <h5 class="title-detail">Distribution</h5>
              <div class="search">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Search Distribution"
                />
              </div>
            </div>
            <div class="list-experiences">
              <div class="row" v-if="distribution.results.length > 0">
                <div
                  class="col-lg-4"
                  v-for="(item, index) in distribution.results"
                  :key="index"
                >
                  <div class="shadow-sm pb-2 bg-white rounded">
                    <div class="title-experiences">{{ item.name }}</div>
                    <div class="owner">Owner:</div>
                    <div class="img-experiences">
                      <img :src="img" alt="Business name" />
                    </div>
                    <div class="date-post">
                      Last update: {{ item.updatedAt }}
                    </div>
                    <div class="location">
                      <label>Launched:</label> {{ item.launchedDate }}
                    </div>
                    <div class="category"><label>Type:</label> Brand Page</div>
                    <div class="category">
                      <label>Experiences:</label>
                      {{ item.stats.experienceCount }}
                    </div>
                    <div class="icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="31"
                        height="24.024"
                        viewBox="0 0 31 24.024"
                      >
                        <g
                          id="ew-icon_new-message"
                          transform="translate(0.5 0.5)"
                        >
                          <path
                            id="Path_12083"
                            data-name="Path 12083"
                            d="M35.991,11.58H9.018A1.515,1.515,0,0,0,7.5,13.1v15.03a1.515,1.515,0,0,0,1.518,1.518h2.058V34.1a.486.486,0,0,0,.832.343l4.8-4.8H35.982A1.515,1.515,0,0,0,37.5,28.128V13.1A1.5,1.5,0,0,0,35.991,11.58Z"
                            transform="translate(-7.5 -11.58)"
                            fill="none"
                            stroke="#b9b9b9"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-miterlimit="10"
                            stroke-width="1"
                          />
                          <g
                            id="Group_4748"
                            data-name="Group 4748"
                            transform="translate(3.969 4.545)"
                          >
                            <line
                              id="Line_194"
                              data-name="Line 194"
                              x2="22.069"
                              fill="none"
                              stroke="#b9b9b9"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              stroke-width="1"
                            />
                            <line
                              id="Line_195"
                              data-name="Line 195"
                              x2="22.069"
                              transform="translate(0 4.304)"
                              fill="none"
                              stroke="#b9b9b9"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              stroke-width="1"
                            />
                            <line
                              id="Line_196"
                              data-name="Line 196"
                              x2="14.576"
                              transform="translate(0 8.617)"
                              fill="none"
                              stroke="#b9b9b9"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              stroke-width="1"
                            />
                          </g>
                        </g>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-if="distribution.results.length == 0">
                <div style="padding-left: 15px; padding-top: 15px">
                  This contest did use any distribution channels.
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-12">
            <button class="btn btn-experience" @click="showFormJoin">
              JOIN CONTEST
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import img from "@/assets/images/img-experience.jpg";
import profile from "@/assets/images/profile-contest.jpg";
import moment from "moment";
export default {
  props: {
    item: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      img: img,
      profile: profile,
      participating: null,
      distribution: null,
    };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    async onLoad() {
      this.participating = await this.$repo.contest.campaignExperiences(
        this.item.id
      );
      this.distribution = await this.$repo.contest.campaignPlatforms(
        this.item.id
      );
    },
    onClickClose() {
      this.$emit("close");
    },
    showFormJoin() {
      this.$emit("formJoin", this.item);
    },
    formatDate(date) {
      return moment(date).format("D/M/YYYY");
    },
  },
};
</script>

<style lang="scss" scoped>
.contest-details {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100vh;
  background-color: rgba($color: #000000, $alpha: 0.9);
  z-index: 1010;

  .container {
    max-width: 1598px;
  }

  .detail {
    width: 100%;
    background-color: #fff;
    padding: 20px;

    .title-detail {
      font-size: 24px;
      font-weight: bold;
      color: var(--experience-color);
    }

    .ps {
      height: 38vh;
    }

    .detail-description {
      width: 100%;
      display: flex;

      .detail-img {
        width: 20%;

        img {
          width: 100%;
          object-fit: cover;
        }
      }

      .detail-name {
        width: 80%;
        padding: 0 15px;
        .description {
          display: flex;

          .contest-name-description {
            width: 50%;
          }
        }
      }
    }

    .box-experiences {
      display: flex;

      h5 {
        margin-right: auto;
      }

      .search {
        width: 340px;
      }
    }

    .list-experiences {
      .title-experiences,
      .owner,
      .date-post,
      .location,
      .category,
      .icon {
        padding: 0 5px;
      }
      .title-experiences {
        background-color: var(--experience-color);
        color: #fff;
        font-size: 12px;
      }

      .owner {
        font-size: 10px;
      }

      .img-experiences {
        img {
          width: 100%;
          object-fit: cover;
        }
      }

      .date-post {
        color: #b9b9b9;
        font-size: 10px;
      }

      .location {
        font-size: 8px;
      }

      .category {
        font-size: 8px;
      }
    }
  }

  .list-description {
    .head-title {
      font-size: 18px;
      font-weight: bold;
    }

    .text-description {
      font-size: 12px;
      margin-bottom: 15px;

      table th {
        font-weight: bold;
      }
    }
  }

  .attributes {
    .attribute {
      display: grid;
      grid-template-columns: 85px 1fr;
      grid-auto-rows: 1fr;
      font-size: 12px;
      line-height: 1.75em;

      .attribute-name {
        font-weight: bold;
      }
    }
  }

  .table-contest {
    width: 100%;
  }

  .btn-experience {
    background-color: var(--experience-color);
  }
}
</style>